import * as Yup from "yup";

export const initialValues = {
  documentTypeId: null,
  preferredDate: null,
  receivingMethod: "app",
  languageFormat: "both",
  description: null,
  // rangevisaDate: null
};

const DocumentSchema = Yup.object().shape({
  documentTypeId: Yup.string().required("Please select."),
  preferredDate: Yup.string().required("Please select."),
  description: Yup.string().required("Please enter."),
  // rangevisaDate: Yup.array()
  //   .of(Yup.date().nullable())
  //   .required("Please select a valid date range.")
  //   .test(
  //     "isValidRange",
  //     "Please select both start and end dates.",
  //     (value) => Array.isArray(value) && value[0] && value[1]
  //   ),
});

export default DocumentSchema;
